export default function delay(interval, count, index) {
  return `${(index * parseFloat(interval) - parseFloat(interval) * count).toFixed(2)}s`;
}